function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBannerClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#F1F1FD",
  style: {
    fill: "#f1f1fd",
    fill: "color(display-p3 .9451 .9451 .9922)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#232265",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "m12.535 5.464-7.07 7.071m0-7.071 7.07 7.071",
  style: {
    stroke: "#232265",
    stroke: "color(display-p3 .1373 .1333 .3961)",
    strokeOpacity: 1
  }
}));
export { SvgBannerClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjkiIGZpbGw9IiNGMUYxRkQiIHN0eWxlPSJmaWxsOiNGMUYxRkQ7ZmlsbDpjb2xvcihkaXNwbGF5LXAzIDAuOTQ1MSAwLjk0NTEgMC45OTIyKTtmaWxsLW9wYWNpdHk6MTsiLz4KPHBhdGggZD0iTTEyLjUzNTIgNS40NjQzNkw1LjQ2NDA5IDEyLjUzNTQiIHN0cm9rZT0iIzIzMjI2NSIgc3R5bGU9InN0cm9rZTojMjMyMjY1O3N0cm9rZTpjb2xvcihkaXNwbGF5LXAzIDAuMTM3MyAwLjEzMzMgMC4zOTYxKTtzdHJva2Utb3BhY2l0eToxOyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS40NjQ4NCA1LjQ2NDM2TDEyLjUzNTkgMTIuNTM1NCIgc3Ryb2tlPSIjMjMyMjY1IiBzdHlsZT0ic3Ryb2tlOiMyMzIyNjU7c3Ryb2tlOmNvbG9yKGRpc3BsYXktcDMgMC4xMzczIDAuMTMzMyAwLjM5NjEpO3N0cm9rZS1vcGFjaXR5OjE7IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";